import React from 'react'
import { AffordabilityModal } from './AffordabilityModal'
import YlopoOptInModal from './YlopoOptInModal'

/*
 Global
 Provides containment for global elements (outside of routing)
 */
const Global = () => (
  <>
    <AffordabilityModal />
    <YlopoOptInModal />
  </>
)

export default Global
